import BoardsAPI from 'dashboard/api/boards';

const state = {
  record: null,
  records: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getBoard($state) {
    return $state.record;
  },
  getBoards($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async getByTeam({ commit }, payload) {
    const args = typeof payload === 'object' ? payload : { teamId: payload };
    const { teamId, boardId = null } = args || {};
    if (!teamId) return;
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await BoardsAPI.findByTeam(teamId);
      let boardToSet = data && data.length ? data[0] : null;
      if (boardId && data && data.length) {
        boardToSet = data.find(board => board.id === boardId) || boardToSet;
      }
      commit('SET_BOARD', boardToSet);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
  async getAll({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await BoardsAPI.get();
      commit('SET_BOARDS', data || []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, payload) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await BoardsAPI.create({ board: payload });
      commit('SET_BOARD', data);
      // refresh list
      const { data: list } = await BoardsAPI.get();
      commit('SET_BOARDS', list || []);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
  async update({ commit }, { id, payload }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await BoardsAPI.update(id, { board: payload });
      commit('SET_BOARD', data);
      const { data: list } = await BoardsAPI.get();
      commit('SET_BOARDS', list || []);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      await BoardsAPI.delete(id);
      const { data: list } = await BoardsAPI.get();
      commit('SET_BOARDS', list || []);
      // clear record if it was the one deleted
      commit('SET_BOARD', null);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_BOARD($state, board) {
    $state.record = board;
  },
  SET_BOARDS($state, boards) {
    $state.records = boards;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
